import { app } from '../../../../../app';
import { Controller } from './directory-manage-domains-azure.controller';

app.component('companyDirectoryIntegrationManageDomainsAzure', {
    bindings: {
        azureStatus: '<',
        companyId: '<',
        domains: '<',
        directory: '<',
    },
    controller: Controller,
    templateUrl: require('./directory-manage-domains-azure.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/directory-integration/manage/domains-azure/directory-manage-domains-azure.component.js